import { ChartBinSize, ChartDefinition, ChartKey, ChartQueryParam, ChartRendererType } from '@frontend/chart/types';

import { EQUIPMENT_CERTIFICATIONS_CHART_ENDPOINT } from '../certificate-chart-endpoints';

export const EQUIPMENT_CERTIFICATIONS_DONUT_CHART_DEFINITION: ChartDefinition = {
    key: ChartKey.EQUIPMENT_CERTIFICATIONS_DONUT,
    chartType: ChartRendererType.PIE,
    endpoint: EQUIPMENT_CERTIFICATIONS_CHART_ENDPOINT,
    filters: [{ key: ChartQueryParam.BIN_SIZE, value: ChartBinSize.FULL_PERIOD }]
};
